import React from 'react';
import AternateRoutesUI from './../../../pages/AlternateRoutes/AlternateRoutesUI'
function AlternateRoutes(props){
  const {alternateRoutes,searchedSrcName,searchedDestName,searchedDate,onClickCb,searchedDateHeading} = props;

return(
    <AternateRoutesUI data={alternateRoutes} searchedSrcName= {searchedSrcName} searchedDestName={searchedDestName} searchedDate={searchedDate} onClickCb={onClickCb} searchedDateHeading={searchedDateHeading}></AternateRoutesUI>
)

 }

 export default AlternateRoutes;